import { render, staticRenderFns } from "./newsGroup.vue?vue&type=template&id=0b8bf67c&scoped=true"
import script from "./newsGroup.vue?vue&type=script&lang=ts"
export * from "./newsGroup.vue?vue&type=script&lang=ts"
import style0 from "./newsGroup.vue?vue&type=style&index=0&id=0b8bf67c&prod&lang=css"
import style1 from "./newsGroup.vue?vue&type=style&index=1&id=0b8bf67c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8bf67c",
  null
  
)

export default component.exports